import { EMPTY, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectBalancingPackageById } from "../../../balancingSelectors/selectBalancingPackages";
import { selectInventoryInfo } from "../../../selectors/selectInventoryInfo";
import { TypeActionInventoryInfo, } from "../../info/inventory/actionInventoryInfo";
import { TypeActionPackageInfo } from "../../info/purchase-packages/actionSetPurchasePackageInfo";
import { actionConsumePackages } from "../actionPackages";
export var epicCheckInstantPackages = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionInventoryInfo.Received ||
            action.type === TypeActionPackageInfo.SetPurchaseInfo;
    }), switchMap(function (action) {
        var state = state$.value;
        var packages;
        if (action.type === TypeActionInventoryInfo.Received) {
            if (action.inventoryInfo && action.inventoryInfo.package) {
                packages = action.inventoryInfo.package;
            }
        }
        else {
            packages = selectInventoryInfo(state).package;
        }
        if (packages === undefined) {
            return EMPTY;
        }
        var packagesToGrant = [];
        for (var _i = 0, packages_1 = packages; _i < packages_1.length; _i++) {
            var currentPackage = packages_1[_i];
            var fullPackage = selectBalancingPackageById(currentPackage.typeId || -1);
            if (fullPackage && fullPackage.instantGrant) {
                packagesToGrant.push({
                    amount: currentPackage.amount.toNumber(),
                    packageId: currentPackage.typeId,
                });
            }
        }
        return of(actionConsumePackages(packagesToGrant));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/item-packages/epics/epicCheckInstantPackages.ts
// module id = 1975
// module chunks = 3